export const itemCategory = [
  {
    path: 'all',
    category: 'shop',
    display: 'All'
  },
  {
    path: 'arrow',
    category: 'label',
    display: 'Arrow'
  },
  {
    path: 'bfi',
    category: 'label',
    display: 'BFI'
  },
  {
    path: 'indicator',
    category: 'label',
    display: 'Indicator'
  },
  {
    path: 'studiocanal',
    category: 'label',
    display: 'Studio Canal'
  },
  {
    path: '4kuhd',
    category: 'format',
    display: '4K Ultra HD'
  },
  {
    path: 'bluray',
    category: 'format',
    display: 'Blu-ray'
  },
  {
    path: 'cd',
    category: 'format',
    display: 'CD'
  },
]

export const findDisplayByPath = (path) => {
  const matchedCategory = itemCategory.find(item => item.path === path);

  return matchedCategory ? matchedCategory.display : null;
};

export const findByPath = (path) => {
  const matchedCategory = itemCategory.find(item => item.path === path);

  return matchedCategory ? { display: matchedCategory.display, category: matchedCategory.category } : null;
};